module.exports = __webpack_public_path__ + "resources/img/img_datahunt4_m.1b74add1efa11e4d8cf22dad6670f53f.png";